import { Link } from 'components/Link'
import { Text } from 'components/Text'
import { useFetchPetAttempt } from 'features/MealPlan/api/queries/useFetchPetAttempt'
import { getStepFromData } from 'features/MealPlan/utils/getStepFromData'
import { useRouter } from 'hooks/useRouter'
import { useTranslation } from 'hooks/useTranslation'
import { ComponentProps } from 'react'
import { GenericObject } from 'types/GenericObject'
import {
  CursorWrapper,
  MealPlanStepperRoot,
  StepContainer,
  StepDot,
  StepTitle,
} from './MealPlanStepper.styles'

type MealPlanStepperOwnProps = ComponentProps<typeof MealPlanStepperRoot>
export type MealPlanStepperProps = MealPlanStepperOwnProps & {}

const PATH_NAMES: GenericObject<number> = {
  '/meal-plan/step-1': 0,
  '/meal-plan/step-2': 1,
  '/meal-plan/step-3': 2,
  '/meal-plan/step-4': 3,
}

type STEPS_NUMBERS = {
  'step-1': number
  'step-2': number
  'step-3': number
  'step-4': number
}

export const MealPlanStepper = (props: MealPlanStepperProps) => {
  const { pathname } = useRouter()
  const { t } = useTranslation()
  const currentStep = PATH_NAMES[pathname]

  const steps = [
    t('meal-plan:step-1.step-name'),
    t('meal-plan:step-2.step-name'),
    t('meal-plan:step-3.step-name'),
    t('meal-plan:step-4.step-name'),
  ]

  const { data: petAttempt } = useFetchPetAttempt({ retry: false })

  let filledStepName = petAttempt ? getStepFromData(petAttempt) : 'step-1'

  let stepsNumbers: STEPS_NUMBERS = {
    'step-1': 1,
    'step-2': 2,
    'step-3': 3,
    'step-4': 4,
  }

  const filledStepNumber = stepsNumbers[filledStepName]

  return (
    <MealPlanStepperRoot role="list" aria-label={t('meal-plan:stepper')} {...props}>
      {steps.map((step, index) => {
        const isPassed = index < currentStep
        const isCurrent = index === currentStep

        return (
          <StepContainer
            key={index}
            data-status={isPassed ? 'complete' : 'incomplete'}
            aria-current={isCurrent ? 'step' : undefined}
          >
            <CursorWrapper disabled={index + 1 > filledStepNumber!}>
              <Link href={`/meal-plan/step-${index + 1}`} passHref>
                <a>
                  <StepDot aria-hidden={true}>
                    <Text size={{ '@initial': 'body', '@bp2': 'headline' }} weight="bold">
                      {index + 1}
                    </Text>
                  </StepDot>
                  <StepTitle>
                    <Text
                      size="small"
                      weight="bold"
                      color={isPassed || isCurrent ? 'tertiary-900' : 'secondary-800'}
                      key={index}
                    >
                      {step}
                    </Text>
                  </StepTitle>
                </a>
              </Link>
            </CursorWrapper>
          </StepContainer>
        )
      })}
    </MealPlanStepperRoot>
  )
}

MealPlanStepper.displayName = 'MealPlanStepper'
